type QueryValue = string | number | boolean | string[] | undefined;

export const buildQuery = (params: Record<string, QueryValue>) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === '') {
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((item) => qs.append(`${key}[]`, item));
    } else {
      qs.append(key, String(value));
    }
  });
  return qs.toString();
};
